<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('addPage.title') }}</span>
            <span class="create__step" v-if="!isVip">{{ $lang('addPage.step') }} {{ step }}/2</span>
        </div>
        <form-page
            :paymentType="paymentType"
            :pageType="2"
            :price="price"
            :master="master"
            :responsible="responsible"
            :partner="partner"
            :burial="burial"
            :burial_id="burial_id"
            :notRedirect="notRedirect">
        </form-page>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Register from "./section/register";
    import Login from "./section/login";
    import VueCropper from "vue-cropperjs";
    import "cropperjs/dist/cropper.css";
    import FormPage from "./formPage";
    import {DataLayer} from "../../utils/data-layer";

    export default {
        name: "free",
        components: {FormPage, Login, Register, VueCropper},
        props: ['master', 'responsible', 'partner', 'price', 'burial', 'burial_id', 'notRedirect'],
        data: () => ({
            paymentType: window.laravel.paymentTypes.page
        }),
        created() {
            this.$dataLayer.push({'event': 'createPagePopup', 'title': 'Кр'});
        },
        computed: {
            ...mapState('create',[
                'step'
            ]),
            isVip() {
                let urlParams = new URLSearchParams(window.location.search);

                return urlParams.get('is_vip');
            },
        },
    }
</script>

<style>
    .el-form-item .el-input__validateIcon {
        display: none;
    }
</style>
